import { render } from "./HeroiconsOutlineRefresh.vue?vue&type=template&id=65d33555"
const script = {}

import exportComponent from "/Users/nazikban/projects/credit-west-second/packages/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineRefresh.vue"]])

export default __exports__